<template>
    <div>
    <div class="floatButton" v-if="show" v-on:click="pageBack()" >
        返回
    </div>
    </div>
</template>

<script>
    export default {
        name: "back-Button",
        data(){
           return {
               show:false
           }
        },
        watch:{
            $route:function(to) {
                var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) != 'micromessenger') {
                    //不在微信中打开才显示返回按钮
                    if (to.path == '/' ||  to.path == '/order'){
                        this.show = false;
                    } else {
                        this.show = true;
                    }
                }
            }
        },
        methods: {
            pageBack() {
                window.history.go(-1);
            },
        }
    }
</script>

<style scoped>
    /**
悬浮按钮
*/
    .floatButton {
        position: fixed;
        bottom: 10px;
        left: 10px;
        z-index: 888;
        background: #23b9ff;
        width: 40px;
        height: 40px;
        border-radius: 40px;
        box-shadow: 2px 2px 2px #888888;
        opacity: 0.8;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
    }

</style>